import uuid from 'uuid/v1';
import intl from 'react-intl-universal';

const defaultModal = {
  visible: false,
  retain: false,
  customFooter: null,
  onClose: () => {},
  onValidate: null,
  onOpen: undefined,
  title: null,
  content: null,
  props: null,
  validateClassName: '',
  validateName: () => intl.get('general.validate').d('Validate'),
  closeName: () => intl.get('general.close').d('Close'),
  closeOnOuterClick: false,
  disableValidate: false,
  closeOnEscape: true,
  validateOnEnter: true,
  modalClass: '',
};

export default function modalReducer(state = defaultModal, action) {
  switch (action.type) {
    case 'SET_MODAL': {
      {
        let oldModal = state;
        const modalID = uuid();
        if (!action.payload.retain) {
          oldModal = { ...defaultModal, modalID };
        }
        return {
          ...oldModal,
          ...action.payload,
        };
      }
    }
    default:
      return state;
  }
}
